import { forwardRef } from 'react';

export interface ISpinnerProps {
  bounce?: boolean;
  className?: string;
  theme?:
    | 'green-fill'
    | 'green-outline'
    | 'red-fill'
    | 'red-outline'
    | 'gray-outline'
    | 'gray-fill';
}

const Spinner = forwardRef(
  (
    { bounce = true, className, theme = 'green-fill' }: ISpinnerProps,
    ref: any,
  ) => {
    return (
      <div className={`${className}`}>
        <div
          ref={ref}
          className={`${bounce ? 'h-16' : ''} flex flex-1 justify-center`}
        >
          <div className="flex justify-center items-center">
            <div
              className={`${
                theme === 'green-fill'
                  ? 'border-t-green border-gray'
                  : 'border-t-white border-green'
              } animate-spin ease-linear rounded-full border-2 h-4 w-4`}
            />
          </div>
        </div>
      </div>
    );
  },
);

export default Spinner;
